import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { workSchedulesService } from '../api/workSchedules.service';
import { WORK_SCHEDULES_KEYS } from './queryKeys';
import { DEFAULT_PAGE_SIZE } from '@/shared/types/pagination';

/**
 * Fetches the paginated list of member work schedule overrides for the active
 * organization. Disabled when no organization is active.
 *
 * @param search - Optional search term sent as `SearchTerm`
 * @param pageIndex - Zero-based page index (converted to 1-based internally)
 * @param pageSize - Items per page
 */
export function useMemberWorkSchedules(
  search: string,
  pageIndex = 0,
  pageSize = DEFAULT_PAGE_SIZE,
) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  const params = {
    SearchTerm: search || undefined,
    Page: pageIndex + 1, // API is 1-based
    PageSize: pageSize,
  };

  return useQuery({
    queryKey: WORK_SCHEDULES_KEYS.membersList(orgId, params),
    queryFn: ({ signal }) => workSchedulesService.getMemberSchedules(params, signal),
    staleTime: 60_000,
    enabled: !!orgId,
    placeholderData: keepPreviousData,
  });
}
